import client from './client';

export interface RegisterPayload {
  username: string;
  password: string;
  display_name?: string;
  contact_phone?: string;
  referral_code?: string;
}

export interface UpdateCurrentUserPayload {
  contact_phone: string | null;
}

export const authApi = {
  login: (username: string, password: string) => client.post('/auth/login', { username, password }),
  register: (payload: RegisterPayload) => client.post('/auth/register', payload),
  logout: () => client.post('/auth/logout'),
  me: () => client.get('/auth/me'),
  updateMe: (payload: UpdateCurrentUserPayload) => client.patch('/auth/me', payload),
};
